<template>
	<component :is="tag" class="flex flex-col space-y-1">
		<span class="text-sm font-bold">
			{{ label }}
		</span>

		<slot />

		<small v-if="note" class="text-xs text-gray-600">
			{{ note }}
		</small>
	</component>
</template>

<script lang="ts" setup>
const properties = defineProps<{
	label: string;
	note?: string;
	noLabel?: boolean;
}>();

const tag = computed(() => (properties.noLabel ? "div" : "label"));
</script>
